var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPrinter = function SvgPrinter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11c0-.6.4-1 1-1h4c.6 0 1 .4 1 1s-.4 1-1 1H8c-.6 0-1-.4-1-1zM8 13c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1s-.4-1-1-1H8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4 3c0-.6.4-1 1-1h10c.6 0 1 .4 1 1v1c0 .6.4 1 1 1h1c.6 0 1 .4 1 1v7c0 .6-.4 1-1 1h-2v3c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1v-3H2c-.6 0-1-.4-1-1V6c0-.6.4-1 1-1h1c.6 0 1-.4 1-1V3zm10 6H6v7h8V9z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgPrinter;